/* istanbul ignore file */

import { FieldStyleEvaluatedAction } from '.';
import { SiteData } from '../../interfaces/site-data';
import { FieldIdentifier } from '../field-identifier';

export class EvaluatedLogicBuilder {
    fieldStyleEvaluatedActions: FieldStyleEvaluatedAction[];
    mapPinColor: number;
    siteData: SiteData;
    fieldsSettableByLogicBuilders: FieldIdentifier[];
    triggerFields: FieldIdentifier[];
}
